import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { BLUR_COMMAND, COMMAND_PRIORITY_EDITOR, EditorState, LexicalEditor, $setSelection } from 'lexical';

type OnBlurPluginProps = {
  onBlur?: (event: FocusEvent, editorState: EditorState, editor: LexicalEditor) => void;
};

export function OnBlurPlugin({ onBlur }: OnBlurPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      BLUR_COMMAND,
      (event) => {
        onBlur?.(event, editor.getEditorState(), editor);
        editor.blur();
        editor.update(() => {
          $setSelection(null);
        });
        return false;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor, onBlur]);

  return null;
}
